<div fxLayout="column" fxLayoutAlign="start center">
    <div class="content-block dx-card responsive-paddings ocl-top-container" style="width: 95vw">
        <div fxLayout="row" fxLayoutAlign="stretch" class="padding-block">
            <h3>Standing Orders</h3>
        </div>
        <form [formGroup]="standingOrderSearchForm" (ngSubmit)="searchStandingOrders()">
            <div class="padding-block" fxLayout="row" fxLayout.xs="column" fxLayoutAlign.xs="start space-between" fxLayoutAlign="space-between ">
                <app-patient-selector fxFlex="20" fxFlex.sm="30" [control]="standingOrderSearchForm.get('patient')"></app-patient-selector>
                <div fxFlex="30" fxFlex.sm="26" class="dx-field" fxLayout="column" >
                    <div fxLayout="row">
                        <div class="dx-field-label" style="width: 50px !important;">Tests </div>
                        <dx-load-indicator [visible]="pickerDataSource === undefined" [height]="16" [width]="16"></dx-load-indicator>
                    </div>
                    <dx-drop-down-box
                        [(value)]="pickerSelectedTestsKey"
                        valueExpr="id"
                        [disabled]="pickerDataSource === undefined"
                        displayExpr="code"
                        placeholder="Select tests..."
                        [showClearButton]="true"
                        [dataSource]="pickerDataSource.value"
                        [ngStyle.xs]="{width: '100%', 'margin-left': '0','margin-right': '0'}"
                        [ngStyle.gt-xs]="{width: '100%', 'margin-left': '4px','margin-right': '4px'}"
                        (onOpened)="resizePickerDropDown()">
                        <div *dxTemplate="let data of 'content'" id="testsPickerContainer">
                            <dx-data-grid
                                #dropDownGrid
                                [dataSource]="pickerDataSource.value"
                                (onEditorPrepared)="cellPrepared($event)"
                                [columns]="['code', 'name', 'alternateNames']"
                                [selection]="{ mode: 'multiple', allowSelectAll: false, selectAllMode:'page', deferred: false, showCheckBoxesMode: 'onClick' }"
                                [hoverStateEnabled]="true"
                                [paging]="{ enabled: true, pageSize: 10 }"
                                [filterRow]="{ visible: true }"
                                [scrolling]="{ mode: 'infinite' }"
                                [showRowLines]="true"
                                [highlightChanges]="true"
                                [allowColumnResizing]="true"
                                [wordWrapEnabled]="true"
                                style="min-width: 100px!important;"
                                [showBorders]="true"
                                [rowAlternationEnabled]="true"
                                [columnAutoWidth]="true"
                                [height]="'100%'"
                                [width]="'100%'"
                                [(selectedRowKeys)]="pickerSelectedTestsKey"
                                [searchPanel]="{ visible: !isPhoneOrTablet, width: 240, placeholder: 'Search...'}"
                                [columnHidingEnabled]="isPhone || isTablet">
                            </dx-data-grid>
                        </div>
                    </dx-drop-down-box>
                </div>
                <app-client-selector fxShow fxHide.lt-md [ngStyle.md]="{width: '50%', 'padding-left': '20px' }"
                                     *ngIf="role !== 'Physician' && role !== 'Patient'" [clearBtn]="false" id="clientSelector"
                                     [control]="standingOrderSearchForm.get('client')"></app-client-selector>

                <app-selector
                    fxShow fxHide.lt-md [ngStyle.md]="{'padding-left': '20px' }" *ngIf="role !== 'Physician' && role !== 'Patient'"
                    [items]="unitDataSource.value"
                    [label]="'Unit'"
                    [remoteOperations]="true"
                    [control]="standingOrderSearchForm.get('unit')"
                    [displayExpr]="'name'"
                    [keyExpr]="'id'">
                </app-selector>

            </div>
            <div fxLayout="row" fxLayoutAlign="end center" class="padding-block" >
                <app-search-btn style="margin-right: 5px" [disabled]="!standingOrderSearchForm.valid" (click)="searchStandingOrders()"></app-search-btn>
                <app-clear-all-btn (click)="clear()"></app-clear-all-btn>
            </div>
        </form>
    </div>
  <dx-tooltip #gridTooltip>
    <div *dxTemplate="let data = data of 'content'">
      Clear Selection
    </div>
  </dx-tooltip>
  <div class="content-block dx-card responsive-paddings ocl-bottom-container" style="width: 95vw !important;">
        <app-standing-order-search-content [filtersSubmitted]="formSubmitted" (refreshed)="searchStandingOrders()"></app-standing-order-search-content>
    </div>
</div>
